/* eslint-disable no-undef */
export function sendGaEvent() {
  // if (window.location.hostname === 'meet.bizbize.live' && gtag) {
  //   gtag('event', 'tıklandı', {
  //     event_category: category,
  //     event_label: label,
  //   });
  // }
}
